'use strict';

import './polyfills/custom_event';
import './polyfills/object';
